/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const BiomethaneSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M17.63 20.16c1.692-1.373 2.761-3.395 2.761-5.65 0-3.033-4.324-8.345-6.63-10.963a1.868 1.868 0 0 0-2.821 0c-2.306 2.618-6.63 7.93-6.63 10.964 0 2.254 1.069 4.276 2.761 5.65a4.691 4.691 0 0 1-.081-.872c0-2.104 3.119-6.451 4.599-8.396a.952.952 0 0 1 1.524 0c1.48 1.945 4.598 6.292 4.598 8.396 0 .297-.028.588-.081.87Zm-3.464 1.648c.952-.553 1.535-1.522 1.535-2.52 0-.11-.063-.474-.349-1.138-.265-.618-.65-1.333-1.107-2.086a42.885 42.885 0 0 0-1.894-2.83 42.846 42.846 0 0 0-1.895 2.83c-.456.753-.842 1.468-1.107 2.086-.286.664-.349 1.027-.349 1.139 0 .997.583 1.966 1.536 2.52a8.639 8.639 0 0 0 3.63 0Z" /></svg>);
const BiomethaneSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={BiomethaneSolidBase} {...rest} ref={ref} />);
export default BiomethaneSolid;